/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Share_WorkflowsInputs */



/**
* | output |
* | --- |
* | "Share AI workflows with colleagues" |
*
* @param {Onboarding_Usage_Share_WorkflowsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_share_workflows = /** @type {((inputs?: Onboarding_Usage_Share_WorkflowsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Share_WorkflowsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Workflows mit Kollegen teilen")
	return /** @type {LocalizedString} */ ("Share AI workflows with colleagues")
});